<template>
  <app-page-layout :title="$t('hr.expense.create_expense')" icon="tw-expense" @close="leavePage">
    <template #content>
      <validation-observer ref="form">
        <v-flex xs12>
          <validation-provider :name="$t('hr.expense.name')" rules="required|max:255" v-slot="{ errors }">
            <v-text-field
              v-model="expense.name"
              :label="$t('hr.expense.name')"
              color="tertiary"
              counter="255"
              clearable
              :error-messages="errors"
            />
          </validation-provider>
        </v-flex>
        <v-flex xs12>
          <validation-provider :name="$t('hr.expense.type')" rules="required" v-slot="{ errors }">
            <expense-type-picker v-model="expense.type" :error-messages="errors" />
          </validation-provider>
        </v-flex>
        <v-flex xs12>
          <validation-provider :name="$t('hr.expense.amount')" rules="required|min_value:1|numeric" v-slot="{ errors }">
            <v-text-field
              v-model.number="expense.requested.amount"
              v-numeric.number.decimal
              type="number"
              :label="$t('hr.expense.amount')"
              color="tertiary"
              clearable
              :error-messages="errors"
            />
          </validation-provider>
        </v-flex>
        <v-flex xs12>
          <validation-provider :name="$t('hr.expense.date')" rules="required" v-slot="{ errors }">
            <date-time-picker
              v-model="expense.timestamp"
              format="YYYY-MM-DDTHH:mm:ss"
              :disabled="loading"
              :label="$t('hr.expense.date')"
              :error-messages="errors"
            />
          </validation-provider>
        </v-flex>
        <v-flex xs12>
          <travel-picker v-model="expense.travel" />
        </v-flex>
        <v-flex xs12>
          <expense-management-picker v-model="expense.expenseManagement" :employee="$store.state.auth.user.id" />
        </v-flex>
        <v-flex xs12>
          <file-upload-picker
            :disabled="loading"
            v-model="expense.attachment"
            :label="$t('hr.expense.attachment')"
            storageType="EXPENSE"
            @send="cb => (onFileSend = cb)"
            onCreate
          />
        </v-flex>
        <v-flex xs12>
          <validation-provider :name="$t('global.description')" rules="max:512" v-slot="{ errors }">
            <v-textarea
              rows="1"
              :label="$t('global.description')"
              v-model="expense.description"
              color="tertiary"
              :counter="512"
              :error-messages="errors"
            />
          </validation-provider>
        </v-flex>
      </validation-observer>
    </template>
    <template #footer>
      <app-page-footer create>
        <template #right>
          <v-btn text @click="validateAndSave" :loading="loading">{{ $t("buttons.save") }}</v-btn>
        </template>
      </app-page-footer>
    </template>
  </app-page-layout>
</template>

<script>
  import Expense from "../model/Expense";

  export default {
    name: "ExpenseCreate",
    components: {
      "expense-type-picker": () => import("../components/expense-type-picker"),
      "currency-picker": () => import("@/components/selectpickers/currency-picker"),
      TravelPicker: () => import("@/components/selectpickers/TravelPicker"),
      ExpenseManagementPicker: () => import("@/components/selectpickers/ExpenseManagementPicker"),
      AppPageFooter: () => import("@/layouts/app-page-footer")
    },
    data: () => ({
      loading: false,
      expense: new Expense(),
      onFileSend: () => {},
      typeCurrencyCode: null
    }),
    watch: {
      type: {
        handler(type) {
          if (type) {
            this.typeCurrencyCode = type.maxAmountWithoutApproval && type.maxAmountWithoutApproval.code;
            this.expense.requested.code = type.maxAmountWithoutApproval && type.maxAmountWithoutApproval.code;
            this.expense.type = type.id;
          } else {
            this.typeCurrencyCode = null;
            this.expense.type = null;
            this.expense.requested.code = null;
          }
        },
        deep: true
      }
    },
    methods: {
      leavePage() {
        this.$router.replace({ name: "expenses" });
      },
      validateAndSave() {
        this.$refs.form.validate().then(valid => {
          if (valid) {
            this.loading = true;
            this.onFileSend().then(uploaded => {
              if (uploaded) {
                this.$api.expenseService
                  .save(this.expense)
                  .then(({ data }) => {
                    if (!data.error) {
                      this.$emit("success:save");
                      this.leavePage();
                    }
                  })
                  .catch(e => {
                    this.$helpers.showNotification(e.message);
                  })
                  .finally(() => {
                    this.loading = false;
                  });
              }
            });
          }
        });
      }
    }
  };
</script>

<style scoped></style>
